import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { OpenItem } from '@/types/models/OpenItem';
import { OpenItemService } from '@/services';
import { logger } from '@/lib/logger';
import { RootState } from '@/state/store';

interface OpenItemsState {
  openItems: OpenItem[];
  isLoading: boolean;
  error: string | null;
  isLoaded: boolean;
  searchQuery: string;
}

const initialState: OpenItemsState = {
  openItems: [],
  isLoading: false,
  error: null,
  isLoaded: false,
  searchQuery: '',
};

export const fetchOpenItems = createAsyncThunk(
  'openItems/fetchAll',
  async () => {
    logger.info('Fetching open items');
    return OpenItemService.getAll();
  }
);

const openItemsSlice = createSlice({
  name: 'openItems',
  initialState,
  reducers: {
    clearOpenItems: (state) => {
      state.openItems = [];
      state.isLoaded = false;
      state.searchQuery = '';
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpenItems.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOpenItems.fulfilled, (state, action: PayloadAction<OpenItem[]>) => {
        state.openItems = action.payload;
        state.isLoading = false;
        state.isLoaded = true;
      })
      .addCase(fetchOpenItems.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch open items';
        state.isLoaded = false;
        logger.error('Failed to fetch open items', { error: action.error });
      });
  },
});

export const { clearOpenItems, setSearchQuery } = openItemsSlice.actions;
export const selectOpenItems = (state: RootState) => state.openItems.openItems;
export const selectOpenItemsLoading = (state: RootState) => state.openItems.isLoading;
export const selectOpenItemsError = (state: RootState) => state.openItems.error;
export const selectOpenItemsLoaded = (state: RootState) => state.openItems.isLoaded;
export const selectOpenItemsSearchQuery = (state: RootState) => state.openItems.searchQuery;

export default openItemsSlice.reducer; 